import type { HelpFile } from '../../types/help'
import { MyAccessTestIds, MyAccessTabId } from '../../../testids/MyAccessTestIds'

export const myAccessHelp: HelpFile = {
  docPage: '/docs/my-iam/my-access',
  texts: {
    [MyAccessTestIds.myAccessOuterTabs]: null,
    [MyAccessTestIds.tab(MyAccessTabId.AccessProfiles)]:
      'Alle aktiven Zugriffsprofil-Zuweisungen dieser Identität — mit Quellregel und Ablaufdatum.',
    [MyAccessTestIds.tab(MyAccessTabId.FunctionGroups)]:
      'Funktionsgruppen-Zuweisungen — Bündel zusammengehöriger Zugriffsprofile, die als Einheit vergeben wurden.',
    [MyAccessTestIds.tab(MyAccessTabId.EffectiveAccess)]:
      'Tatsächlich wirksame Berechtigungen — unabhängig davon, über welchen Weg sie vergeben wurden.',
    [MyAccessTestIds.tab(MyAccessTabId.Timeline)]:
      'Chronologische Aufzeichnung aller Zugriffsänderungen dieser Identität.',
    [MyAccessTestIds.tab(MyAccessTabId.Assignments)]:
      'Eine Zeile pro aktivem Zugriffsprofil dieser Identität.',
    [MyAccessTestIds.tab(MyAccessTabId.FunctionGroupAssignments)]:
      'Eine Zeile pro Funktionsgruppen-Zuweisung dieser Identität.',
    [MyAccessTestIds.tab(MyAccessTabId.FunctionGroupTimeline)]:
      'Chronologische Aufzeichnung aller Funktionsgruppen-Änderungen dieser Identität.',
    [MyAccessTestIds.myAccessRow]:
      'Eine Zugriffsprofil-Zuweisung — Status, beitragende Quellen und Ablaufdatum.',
    [MyAccessTestIds.myEffectiveAccessRow]:
      'Eine effektive Berechtigung — Ressource, erlaubte Operation und beitragende Zuweisungen.',
    [MyAccessTestIds.myEffectiveAccessScopeHint]:
      'Geltungsbereich der Liste, einschließlich aktiver Filter.',
    [MyAccessTestIds.myFgAssignmentRow]:
      'Eine Funktionsgruppen-Zuweisung — Gruppenname, Status und beitragende Quellen.',
    [MyAccessTestIds.myFgEmpty]:
      'Keine Funktionsgruppen-Zuweisungen für diese Identität.',
    [MyAccessTestIds.colAccessProfiles]:
      'In dieser Zuweisung enthaltene Zugriffsprofile.',
    [MyAccessTestIds.colSources]:
      'Quellen der Zuweisung — direkt, Rolle, Auto-Zuweisungsregel oder Funktionsgruppe.',
    [MyAccessTestIds.colStatus]: null,
    [MyAccessTestIds.colExpiresAt]: null,
    [MyAccessTestIds.colExpand]: null,
    [MyAccessTestIds.colEaEnforcementObject]:
      'Enforcement-Objekt, das durch diese effektive Berechtigung gewährt wird.',
    [MyAccessTestIds.colEaOperation]:
      'Auf der Ressource erlaubte Operation (Lesen, Schreiben, Ausführen usw.).',
    [MyAccessTestIds.colEaResource]:
      'Ressource, auf die sich diese effektive Berechtigung bezieht.',
    [MyAccessTestIds.colEaSourcesCount]:
      'Anzahl der Quellen, die zu dieser effektiven Berechtigung beitragen.',
    [MyAccessTestIds.colEaSystem]:
      'Zielsystem, auf das sich diese effektive Berechtigung bezieht.',
    [MyAccessTestIds.colEaValidFrom]:
      'Datum, ab dem diese effektive Berechtigung gilt.',
    [MyAccessTestIds.colEaValidTo]:
      'Datum, bis zu dem diese effektive Berechtigung gilt.',
    [MyAccessTestIds.colFgName]: null,
    [MyAccessTestIds.colFgStatus]: null,
    [MyAccessTestIds.colFgSources]:
      'Quellen dieser Funktionsgruppen-Zuweisung.',
    [MyAccessTestIds.colFgExpiresAt]: null,
  },
}
